/*
 * **Daz**
 * AUTO IMAGE ROTATOR
 * v1.2
 *
 * This script automatically rotates through a gallery of images on a product page.  It 
 * will pause operation if the window does not have focus, or the user activates the search bar.
 * It will stop rotating completely if the user actually selects one of the images.
 */

// Only do anything if jQuery isn't defined
if (typeof jQuery == 'undefined') {
  if (typeof $ == 'function') {
    // warning, global var
    var thisPageUsingOtherJSLibrary = true;
  }

  function getScript(url, success) {
    var script = document.createElement('script');
    script.src = url;

    var head = document.getElementsByTagName('head')[0],
    done = false;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function() {

      if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
        done = true;

        // callback function provided as param
        success();

        script.onload = script.onreadystatechange = null;
        head.removeChild(script);
      };
    };
    
    head.appendChild(script);
  };

  getScript('http://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js', function() {

  if (typeof jQuery == 'undefined') {
      // Super failsafe - still somehow failed...
	  console.log("[DAR] Couldn't initiate automatic image rotator - could not load jQuery!");
  } else {
      // jQuery loaded! Make sure to use .noConflict just in case
      startTheShow();

      if (thisPageUsingOtherJSLibrary) {
        // Run your jQuery Code
      } else {
        // Use .noConflict(), then run your jQuery Code
        
      }
    }
  });

} else { // jQuery was already loaded
  // Run your jQuery Code
  startTheShow();
};

var theLooper;
var selectedImage;

function startTheShow() {
  jQuery(document).ready(function() {
    
    // Note: We have to use "mousedown" here, NOT "click", because we trigger click() in the rotation function
    // so as to make sure the events that would be fired if the user clicked the thumbnail bubble up.  We catch 
    // mousedown() here so as to differentiate between the user clicking, and the function clicking..
    jQuery("IMG", "DIV.product-thumbnails").on("mousedown", function() {
      selectedImage = jQuery(this).index();
      
      // Glam up the thumbnail
      pimpThumb(jQuery(this));
      
      if (theLooper) {
        //console.log("[DAR] User clicked image, ending loop.");
        clearInterval(theLooper);
      }
    });
    
    // Start the auto rotation
    goAutoRotate();
  });
}

function goAutoRotate() {
  //console.log("[DAR] Starting up..");
  
  var rotate_time = 4000;
  var image_count = jQuery("IMG", "DIV.product-thumbnails").length;
  var currentImage = 1;
  var cImg;
  
  //console.log("[DAR] image_count = " + image_count);
  
  if (image_count > 1) {
    theLooper = setInterval(function() {
      // Only loop if window has focus..
      if (document.hasFocus() && (jQuery("DIV.header-livesearch").is(":hidden") && !jQuery(".navmenu-submenu").is(":visible"))) {
      	cImg = jQuery("IMG", "DIV.product-thumbnails").eq(currentImage);
      
      	jQuery(cImg).click();
      	pimpThumb(cImg);
      
      	if (++currentImage == image_count) {
          currentImage = 0;	  
      	}
      }
    }, rotate_time);
  }
}

function pimpThumb(cImg) {
  if (cImg) {
    jQuery("IMG", jQuery(cImg).parent()).removeClass("selected");
  	jQuery(cImg).addClass("selected"); 
  }
}